/**
 * @generated SignedSource<<c90df2fcfb633dc3714e5bb0f0355f82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersonalizedEmailTemplateInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePersonalizedEmailTemplateInput;
};
export type deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly deletePersonalizedEmailTemplate: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null;
    };
  };
};
export type deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation = {
  response: deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation$data;
  variables: deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31e0ab4d2200d079ff0c056ae79ab14c",
    "id": null,
    "metadata": {},
    "name": "deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation(\n  $input: DeletePersonalizedEmailTemplateInput!\n) {\n  Admin {\n    Email {\n      deletePersonalizedEmailTemplate(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "85fb5ec574750c3a724454f2dd3ac3cd";

export default node;
